import React, { useEffect, useState } from 'react';

import Welcome from './Welcome/Welcome';
import { useLiveQuery } from 'dexie-react-hooks';
import { useGetMailboxData } from '../../../app/useGetMailboxData';
import Mailbox, { getCurrentMailboxQuery } from '../../../model/mailbox';
import { LandingPageFlavorEnum } from './Welcome/welcomeFlavors.types';
import { useNavigate } from 'react-router-dom';
import EnterEmail from './EnterEmail/EnterEmail';
import WelcomePhotoCleaner from './Welcome/WelcomePhotoCleaner';
import OnboardingSlideshow from './OnboardingSlideshow/OnboardingSlideshow';
import AnalyticsService from '../../../services/analytics/analyticsService';
import { EventName } from '../../../services/analytics/providers/analyticsProvider';

export type OnboardBeforeSignInFlowProps = {
  landingPageFlavor: LandingPageFlavorEnum;
  nativeAppFunnelMode: boolean;
};

const USE_PHOTO_CLEANING_FEATURES = false;

function OnboardBeforeSignInFlow(props: OnboardBeforeSignInFlowProps) {
  const { landingPageFlavor, nativeAppFunnelMode } = props;

  const mailbox: Mailbox | undefined | null = useLiveQuery(getCurrentMailboxQuery);
  const { hasTokenAndUserInfoScopes } = useGetMailboxData(mailbox);

  const [onboardingStep, setOnboardingStep] = useState<'WELCOME' | 'EMAIL' | 'SLIDESHOW'>(
    'WELCOME'
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (hasTokenAndUserInfoScopes) {
      navigate('/');
    }
  }, [hasTokenAndUserInfoScopes]);

  useEffect(() => {
    if (onboardingStep === 'WELCOME') {
      AnalyticsService.track(EventName.NATIVE_FUNNEL_START);
    } else if (onboardingStep === 'SLIDESHOW') {
      AnalyticsService.track(EventName.NATIVE_FUNNEL_SLIDESHOW);
    } else if (onboardingStep === 'EMAIL') {
      AnalyticsService.track(EventName.ENTER_EMAIL_VISIT);
    }
  }, [onboardingStep]);

  if (onboardingStep === 'WELCOME') {
    if (USE_PHOTO_CLEANING_FEATURES) {
      return (
        <WelcomePhotoCleaner
          next={() => {
            setOnboardingStep('SLIDESHOW');
          }}
          landingPageFlavor={landingPageFlavor}
        ></WelcomePhotoCleaner>
      );
    } else {
      return (
        <Welcome
          next={() => {
            setOnboardingStep('SLIDESHOW');
          }}
          landingPageFlavor={landingPageFlavor}
          showSignInNext={false}
        ></Welcome>
      );
    }
  }

  if (onboardingStep === 'SLIDESHOW') {
    return (
      <OnboardingSlideshow
        next={() => {
          setOnboardingStep('EMAIL');
        }}
        nativeAppFunnelMode={nativeAppFunnelMode}
      />
    );
  }

  return (
    <EnterEmail
      next={(email) => {
        navigate(`/upgrade?email=${email}`);
      }}
    ></EnterEmail>
  );
}

export default OnboardBeforeSignInFlow;
